module.exports = __webpack_public_path__ + "static/img/_8.a47c4dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_8.png
// module id = q+99
// module chunks = 1